import type {Criterion, CriterionField, Matcher} from '../criteria.types';

export default class InCriterion implements Criterion {
    public value: any[];

    constructor(public field: CriterionField, matcher?) {
        this.value = matcher ? matcher.value : [];
    }

    public clear() {
        this.value = [];
    }

    public isEmpty() {
        return !this.value || this.value.length === 0;
    }

    public toMatcher(): Matcher {
        return {
            in: {
                value: this.value
            }
        };
    }
}
